import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Input } from 'semantic-ui-react';

const MultiLanguageInput = ({
  name,
  currentLanguage = 'en',
  referenceValue = '',
  ...props
}) => {
  const { t } = useTranslation();
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const handleInputChange = (value) => {
    const newValue = {
      ...field.value,
      [currentLanguage]: value,
    };
    setValue(newValue);
  };

  const getInputValue = () => {
    return field.value?.[currentLanguage] || '';
  };

  return (
    <div className="multilang-input-container">
      <div className="formik-custom-field act-inputs-new">
        <label
          className={props.requiredStar ? 'required-stars' : ''}
          htmlFor={props.id || props.name}
        >
          {props.labelText}
        </label>
        <Input
          {...props}
          name={`${name}.${currentLanguage}`}
          value={getInputValue()}
          onChange={(e, data) => handleInputChange(data.value)}
          error={Boolean(meta.touched && meta.error)}
        />
        {meta.touched && meta.error && (
          <div className="invalid-feedback">
            {typeof meta.error === 'string'
              ? meta.error
              : meta.error[currentLanguage] || Object.values(meta.error)[0]}
          </div>
        )}
      </div>

      {referenceValue && currentLanguage !== 'en' && (
        <div className="reference-text">
          <small className="text-muted">
            {t('common.reference')} (en): "{referenceValue}"
          </small>
        </div>
      )}
    </div>
  );
};

export default MultiLanguageInput;
